'use strict';

parcelService.$inject = ["api", "config", "$stateParams", "authService"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.parcelService = parcelService;

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*@ngInject*/
function parcelService(api, config, $stateParams, authService) {
    var packageLineNumber = 1;
    var insuranceLineNumber = 2;

    return {
        init: init,
        validateReceiver: validateReceiver,
        getOrderTypes: getOrderTypes,
        add: add,
        get: get,
        search: search,
        getRecentOrders: getRecentOrders,
        getLabelDownloadUrl: getLabelDownloadUrl,
        getStateHistory: getStateHistory,
        getOrderStateContext: getOrderStateContext,
        getOrderStateIcon: getOrderStateIcon,
        cancel: cancel
    };

    function init() {
        var _this = this;

        if (!this.podPackageTypes) {
            return getPackageTypes().then(function (response) {
                return _this.podPackageTypes = response;
            });
        }
    }

    function add(orderTypeId, parcelAdd) {
        return api.podOrderAdd.execute({ orderTypeId: orderTypeId }, parcelAdd).$promise.then(function (resource) {
            return resource;
        });
    }

    function validateReceiver(licenseNumber) {
        return api.podValidateContact.get({ licenseNumber: licenseNumber }).$promise.then(function (resource) {
            return resource;
        });
    }

    function getOrderTypes() {
        return api.podOrderTypes.get().$promise.then(function (resource) {
            return resource;
        });
    }

    function getPackageTypes(customerNumber) {
        return api.podPackageTypes.get({ customerNumber: customerNumber }).$promise.then(function (resource) {
            return resource;
        });
    }

    function get(id) {
        return api.pod.get({ id: id }).$promise.then(function (result) {
            result.lines = result.lines.map(function (line) {
                var packageInvoiceLine = line.invoiceLines.find(function (invoiceLine) {
                    return invoiceLine.lineNumber === packageLineNumber;
                });
                var insuranceInvoiceLine = line.invoiceLines.find(function (invoiceLine) {
                    return invoiceLine.lineNumber === insuranceLineNumber;
                });
                line.isFree = packageInvoiceLine ? packageInvoiceLine.isFree : null;
                line.packageInvoiceAmount = packageInvoiceLine ? packageInvoiceLine.invoiceAmount : null;
                line.insuranceInvoiceAmount = insuranceInvoiceLine ? insuranceInvoiceLine.invoiceAmount : null;
                return line;
            });
            return result;
        });
    }

    function getRecentOrders() {
        var search = {
            dateFrom: (0, _moment2.default)().add(-6, 'months').format('YYYY-MM-DD'),
            take: 10
        };
        return api.podSearch.search(search).$promise.then(function (resource) {
            return resource.results;
        });
    }

    function search(search) {
        return api.podSearch.search(search).$promise.then(function (resource) {
            return resource;
        });
    }

    function getLabelDownloadUrl(id) {
        return config.webApiBaseUrl + ('pod/' + id + '/downloadLabel?lang=' + $stateParams.language + '&access_token=' + authService.accessToken);
    }

    function getStateHistory(id) {
        return api.podLineStateHistory.get({ lineId: id }).$promise.then(function (resource) {
            return resource;
        });
    }

    function cancel(orderTypeId, lineIds) {
        return api.podOrderDetail.cancel({ orderTypeId: orderTypeId }, lineIds).$promise.then(function (resource) {
            return resource;
        });
    }

    function getOrderStateContext(code) {
        var context = void 0;

        switch (code) {
            case 'CREATED':
                context = 'secondary';
                break;
            case 'REG':
                context = 'secondary';
                break;
            case 'PICK':
                context = 'info';
                break;
            case 'TRANSIT':
                context = 'info';
                break;
            case 'TOURDEL':
                context = 'info';
                break;
            case 'DELIV':
                context = 'success';
                break;
            case 'ANO':
                context = 'error';
                break;
            case 'CANCEL':
                context = 'error';
                break;

            default:
                context = 'success';
        }
        return context;
    }

    function getOrderStateIcon(code) {
        var icon = void 0;

        switch (code) {
            case 'CREATED':
                icon = 'ico-truck';
                break;
            case 'REG':
                icon = 'ico-truck';
                break;
            case 'PICK':
                icon = 'ico-truck';
                break;
            case 'TRANSIT':
                icon = 'ico-truck';
                break;
            case 'TOURDEL':
                icon = 'ico-truck';
                break;
            case 'DELIV':
                icon = 'ico-truck';
                break;
            case 'ANO':
                icon = 'ico-truck';
                break;
            case 'CANCEL':
                icon = 'ico-truck';
                break;

            default:
                icon = 'ico-truck';
        }

        return icon;
    }
}


//////////////////
// WEBPACK FOOTER
// ./common/services/parcelService.js
// module id = 821
// module chunks = 0